import FaltantesModal from "./FaltantesModal";
export default FaltantesModal;